import { apiClient, API_BASE_URL } from './apiClient';

const BASE = `${API_BASE_URL}/api/purchase-receipts`;

export const purchaseReceiptsAPI = {
  async getAll() {
    return apiClient(`${BASE}/`);
  },

  async getById(id) {
    return apiClient(`${BASE}/${id}`);
  },

  async create(data) {
    return apiClient(`${BASE}/`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async update(id, data) {
    return apiClient(`${BASE}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  async delete(id) {
    return apiClient(`${BASE}/${id}`, {
      method: 'DELETE',
    });
  },

  async bulkDelete(ids) {
    return apiClient(`${BASE}/bulk-delete`, {
      method: 'POST',
      body: JSON.stringify({ ids }),
    });
  },

  async confirm(id) {
    return apiClient(`${BASE}/${id}/confirm`, {
      method: 'POST',
    });
  },
};

export default purchaseReceiptsAPI;
